import React from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const EmailAccountEditorModal = ({
  open,
  onClose,
  onSave,
  saving,
  editingAccount,
  emailForm,
  handleChange,
  setEmailForm,
  signatureModules,
  signatureFormats
}) => {
  if (!open) return null;

  return (
    <div className="modal fade show" style={{ display: 'block', background: 'rgba(0,0,0,0.45)' }}>
      <div className="modal-dialog modal-lg modal-dialog-scrollable">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{editingAccount ? 'Editar cuenta de email' : 'Nueva cuenta de email'}</h5>
            <button className="btn-close" onClick={onClose}></button>
          </div>
          <div className="modal-body">
            <form onSubmit={onSave} className="row g-2">
              <div className="col-12">
                <label className="form-label">Nombre</label>
                <input className="form-control" name="name" value={emailForm.name} onChange={handleChange} required />
              </div>
              <div className="col-6">
                <label className="form-label">From name</label>
                <input className="form-control" name="from_name" value={emailForm.from_name} onChange={handleChange} required />
              </div>
              <div className="col-6">
                <label className="form-label">From email</label>
                <input className="form-control" name="from_email" value={emailForm.from_email} onChange={handleChange} required />
              </div>
              <div className="col-12">
                <label className="form-label">IMAP host</label>
                <input className="form-control" name="imap_host" value={emailForm.imap_host} onChange={handleChange} required />
              </div>
              <div className="col-6">
                <label className="form-label">IMAP puerto</label>
                <input className="form-control" type="number" name="imap_port" value={emailForm.imap_port} onChange={handleChange} required />
              </div>
              <div className="col-6 d-flex align-items-end">
                <div className="form-check">
                  <input className="form-check-input" type="checkbox" name="imap_secure" checked={emailForm.imap_secure} onChange={handleChange} />
                  <label className="form-check-label">IMAP seguro</label>
                </div>
              </div>
              <div className="col-6">
                <label className="form-label">IMAP usuario</label>
                <input className="form-control" name="imap_user" value={emailForm.imap_user} onChange={handleChange} required />
              </div>
              <div className="col-6">
                <label className="form-label">IMAP contraseña</label>
                <input className="form-control" type="password" name="imap_password" value={emailForm.imap_password} onChange={handleChange} placeholder={editingAccount ? '*****' : ''} />
              </div>
              <div className="col-12">
                <label className="form-label">SMTP host</label>
                <input className="form-control" name="smtp_host" value={emailForm.smtp_host} onChange={handleChange} required />
              </div>
              <div className="col-6">
                <label className="form-label">SMTP puerto</label>
                <input className="form-control" type="number" name="smtp_port" value={emailForm.smtp_port} onChange={handleChange} required />
              </div>
              <div className="col-6 d-flex align-items-end">
                <div className="form-check">
                  <input className="form-check-input" type="checkbox" name="smtp_secure" checked={emailForm.smtp_secure} onChange={handleChange} />
                  <label className="form-check-label">SMTP seguro</label>
                </div>
              </div>
              <div className="col-6">
                <label className="form-label">SMTP usuario</label>
                <input className="form-control" name="smtp_user" value={emailForm.smtp_user} onChange={handleChange} required />
              </div>
              <div className="col-6">
                <label className="form-label">SMTP contraseña</label>
                <input className="form-control" type="password" name="smtp_password" value={emailForm.smtp_password} onChange={handleChange} placeholder={editingAccount ? '*****' : ''} />
              </div>
              <div className="col-6">
                <label className="form-label">Carpeta inbox</label>
                <input className="form-control" name="inbox_folder" value={emailForm.inbox_folder} onChange={handleChange} />
              </div>
              <div className="col-12">
                <label className="form-label">Firma</label>
                <ReactQuill
                  theme="snow"
                  value={emailForm.signature}
                  onChange={(val) => setEmailForm((prev) => ({ ...prev, signature: val }))}
                  modules={signatureModules}
                  formats={signatureFormats}
                  placeholder="Texto de firma que se añadirá al enviar correos"
                />
              </div>
              <div className="col-6 d-flex align-items-end">
                <div className="form-check">
                  <input className="form-check-input" type="checkbox" name="active" checked={emailForm.active} onChange={handleChange} />
                  <label className="form-check-label">Activa</label>
                </div>
              </div>
            </form>
          </div>
          <div className="modal-footer">
            <button className="btn btn-outline-secondary" onClick={onClose}>Cancelar</button>
            <button className="btn btn-primary" onClick={onSave} disabled={saving}>
              {saving ? 'Guardando...' : 'Guardar'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmailAccountEditorModal;
